/*
 * ROVE NEXT OUR STORY + COLLECTIONS + SUSTAINABILITY PAGE: BACK-BUTTON
 * SCROLL RESTORE.
 * Added 21 Sep 2026, Stevie: "when they click SHOP and leave the page, if
 * they click back it should take them back to the spot they left."
 * Extended 23 Sep 2026 to the sustainability page, same reported behaviour,
 * once that page picked up its own outbound buttons (Shop the Collection,
 * Product Care, Warranty Policy).
 *
 * Direct copy of the proven fix already shipped for the homepage in
 * assets/rn-home-scroll-restore.js (31 Aug 2026) -- same root cause, same
 * technique, just scoped to these three templates instead of index. See that
 * file's own header comment for the full explanation of why the browser's
 * native restore isn't enough on its own here. Short version: it already
 * works for free whenever the page is served from bfcache; this only
 * matters on the fresh-reload path, and the safety net costs nothing on the
 * bfcache path since 'pagehide' plus a back_forward check make it a no-op
 * there.
 *
 * Scoped via layout/theme.liquid: the <script src> for this file, and the
 * history.scrollRestoration = 'manual' line that must run before it, are
 * both only printed when template.suffix is 'our-story', 'next-collection'
 * or 'sustainability'. Every other page keeps the browser's default
 * behaviour, unchanged.
 */
(function () {
  var main = document.getElementById('MainContent');
  if (!main) return;
  var tpl = main.getAttribute('data-template');
  if (tpl !== 'page.our-story' && tpl !== 'collection.next-collection' && tpl !== 'page.sustainability') return;

  var KEY = 'rn-' + tpl.replace('.', '-') + '-scroll-y';

  window.addEventListener('pagehide', function () {
    try {
      sessionStorage.setItem(KEY, String(window.scrollY));
    } catch (e) {
      /* sessionStorage unavailable (private mode, etc.) -- nothing to restore next time, fail silent */
    }
  });

  var navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var isBackForward = navEntry
    ? navEntry.type === 'back_forward'
    : !!(performance.navigation && performance.navigation.type === 2);
  if (!isBackForward) return;

  var saved;
  try {
    saved = sessionStorage.getItem(KEY);
  } catch (e) {
    saved = null;
  }
  if (saved === null) return;

  var y = parseInt(saved, 10);
  if (!isFinite(y)) return;

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      window.scrollTo(0, y);
    });
  });
})();
